module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5d1ae91085a7e2014a3a09261ff0526b.png";